import { render, staticRenderFns } from "./numbersTable.vue?vue&type=template&id=2336345c"
import script from "./numbersTable.vue?vue&type=script&lang=js"
export * from "./numbersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports